module.exports = __webpack_public_path__ + "static/media/leila.96b2c545.jpg";